import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { InvoicesItemFormPageContext } from "./InvoicesItemFormPageContext";

export const useInvoicesItemFormPageContext = () => {
  const context = useContext(InvoicesItemFormPageContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useInvoicesItemFormPageContext",
      "InvoicesItemFormPageContext"
    );
  }

  return context;
};
